module.exports = __webpack_public_path__ + "static/js/2.76641552.chunk.worker.js"